// extracted by mini-css-extract-plugin
module.exports = {"header":"errorPage_header___D_CG","logo":"errorPage_logo__jMXQa","title":"errorPage_title__ws2Ms","footer":"errorPage_footer__Jjop5","copyright":"errorPage_copyright__p5nAm"};